import { Component, Input, OnInit } from '@angular/core';
import { ReadReceiptComponent } from '../read-receipt/read-receipt.component';

import { ContentInteractive } from '../../translator/translatorUtils';
@Component({
    selector: 'app-interactive-message-chat-bubble',
    templateUrl: './interactive-message-chat-bubble.component.html',
    styleUrls: ['./interactive-message-chat-bubble.component.scss'],
    imports: [ReadReceiptComponent]
})
export class InteractiveMessageChatBubbleComponent implements OnInit {
  @Input()
  content: ContentInteractive;

  constructor() { }

  ngOnInit() {}

}
